// The Sales page's view (My sales | branch) and the Centre Director's picked agent,
// kept for the tab so opening a sale and coming back lands on the same list.
// Shared by the phone and desktop pages, so either layout reads what the other left.
const VIEW_KEY = 'cid.sales.view';
const AGENT_KEY = 'cid.sales.branchAgent';

const read = (k) => { try { return sessionStorage.getItem(k); } catch { return null; } };
const write = (k, v) => { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch { /* private mode */ } };

export const loadSalesView = () => read(VIEW_KEY) || 'mine';
export const saveSalesView = (v) => write(VIEW_KEY, v);

/** { agent_id, name } or null. */
export const loadBranchAgent = () => {
  try { const m = JSON.parse(read(AGENT_KEY) || 'null'); return m?.agent_id ? m : null; } catch { return null; }
};
export const saveBranchAgent = (m) => write(AGENT_KEY, m ? JSON.stringify({ agent_id: m.agent_id, name: m.name }) : null);
